/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContentPageListModel } from './contentPageListModel';
import { ContentPageTitleModel } from './contentPageTitleModel';
import { StringWithHyperlinkParametersModel } from './stringWithHyperlinkParametersModel';


/**
 * Model representing a section of content to be translated to HTML by the client
 */
export class ContentPageSectionModel { 
    /**
     * Enumeration defining how lists are arranged within the section: Vertical = 0, Horizontal = 1
     */
    ListArrangement?: ContentPageSectionModel.ListArrangementEnum;
    /**
     * List of content page lists to be displayed within the section between the section header and footer
     */
    Lists?: Array<ContentPageListModel>;
    /**
     * Title of page, section or list
     */
    Title?: ContentPageTitleModel;
    /**
     * Header text for the page, section or list displayed after the title and before the content
     */
    Header?: StringWithHyperlinkParametersModel;
    /**
     * Footer text for the page, section or list displayed at the bottom after the content
     */
    Footer?: StringWithHyperlinkParametersModel;
}
export namespace ContentPageSectionModel {
    export type ListArrangementEnum = 0 | 1;
    export const ListArrangementEnum = {
        NUMBER_0: 0 as ListArrangementEnum,
        NUMBER_1: 1 as ListArrangementEnum
    };
}



// WEBPACK FOOTER //
// ./src/app/model/contentPageSectionModel.ts